import Sidebarprojects from '../Sidebar/Sidebarprojects';
import Sidebarblank from '../Sidebar/Sidebarblank';
import '../Sidebar/Sidebardigital';
import Irrigation_text from './irrigation_text.png';
import Irrigation_tubewell from './tubewell.png';
import Irrigation_gatisheel from './gatisheel.png';
import Farmer_Karnal from './farmer_karnal.png';
import Farmer_Benefits from './farmer_benefits.mp4';

import '../Irrigation/Irrigation.css';
export default function Irrigation()
{
    return(
       <>
      <div className="row">
        <div className="col-2 custom-display">
          <Sidebarprojects />
        </div>
        <div className="col-8 custom-width">
            <br/><br/>
            <h4><strong>Project Description</strong></h4><br/>
            <p> Agriculture pumps of 300+ farmers are automated in the state of <strong>Haryana - Karnal and Yamunanagar district</strong></p>
            <br/>
            <h4> <strong>Problem Statement</strong></h4><br/>
              <p>-- Under-ground water level is <strong>going down by up to 1m/year</strong></p>
              <p> -- <strong>Higher input cost</strong> - Farmers are required to use higher capacity agriculture pump in their farm</p>
              <p> -- <strong>Excess water usage</strong> - Water is running in the farm based on power availability</p>
              <p> -- Food Quality - Excessive water usage promotes <strong>heavy usage of pesticides/fertilizers</strong></p>
            {/* <li>Under-ground water level is going down by up to 1m/year</li>
            <li><strong>Higher input cost</strong> - Farmers are required to use higher capacity agriculture pump in their farm</li>
            <li><strong>Excess water usage</strong> - Water is running in the farm based on power availability</li>
            <li>Food Quality - Excessive water usage promotes <strong>heavy usage of pesticides/fertilizers</strong></li> */}
           
        <br/>
        <img className="image_style" src={Irrigation_tubewell} style={{width: '150%', height: 'auto', margin: '0', maxWidth: '100%' }} alt=" "/>
        
        <br/><br/><br/>      

        <h4>        <strong>What is the scope of the project</strong></h4> <br/>
          <p>  1.	Agriculture pump to be controlled by the farmer via mobile</p>
          <p>  2.	Remote setting - Timer and scheduler facility</p>
            <p>3.	Farmer should get alert in the mobile for phase failure, over voltage and overload current at the farm</p>
            <p>4.	Motor run status, duration and Power On and Off information</p>
            <p>5.	The solution should retrofit to the existing infrastructure no change in the starter and motor</p>
            <br/>
        <h4><strong>Our Solution</strong></h4>
        <p> Irrigation in agriculture is going through rapid transformation where <strong>the water will be used as per the need of the farm </strong> 
             not as per the power availability or experience</p> 
             <br/><br/>
             {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}> */}
             <img src={Farmer_Karnal} style={{width: '150%', height: 'auto', margin: '0', maxWidth: '100%' }} alt=" "/>
             <p style={{textAlign: 'center'}}>***<strong>Installation in Karnal - </strong>Farmer Permission is taken for this image***</p>
             <br/><br/><br/><br/>

             <img src={Irrigation_gatisheel} style={{width: '150%', height: 'auto', margin: '0', maxWidth: '100%' }} alt=" "/>
             <p style={{textAlign: 'center'}}>***<strong>Installation image- </strong> - Unit Installed in Yamunanagar, Haryana***</p>
             
             <br/><br/><br/>
            <video style={{
              width: '100%',
              height: '360px',
              margin: '0',
              maxWidth: '100%',
              border: '2px solid #007bff', // Border color: Blue
              borderRadius: '10px', // Optional: Add rounded corners
              boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.2)' // Optional: Add a subtle shadow
              }}  controls>
              <source src={Farmer_Benefits} type="video/mp4" />
              Your browser does not support the video tag.
            </video> 
            <p style={{textAlign: 'center'}}>***<strong>Testimonial</strong> - Farmer Permission is taken for this video***</p>

             <br/><br/><br/><br/>
             
             <img src={Irrigation_text} style={{width: '120%', height: 'auto', margin: '0', maxWidth: '100%' }} alt=" "/>
            {/* </div>  */}
            <br/><br/><br/>
            <p><strong>Farmer get the irrigation advisory through the Gatisheel app based on above parameters and Farmers can switch on the motor
                from anywhere from their mobile phone </strong>
            </p>
            <br/><br/>       
        
        </div>
        <div className="col-2 custom-display">
          <Sidebarblank />
        </div>
        </div>
     </>
    )   
   };